'use client';

import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps, Card, type CardProps, CardContent, type IconButtonProps, useMediaQuery } from '@mui/material';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { theme } from '../../theme';
type Props = {
  backNode: React.ReactNode;
  boxProps?: BoxProps;
  cardProps?: CardProps;
  iconButtonProps?: IconButtonProps;
  customFlipIcon?: React.ReactNode;
  frontNode: React.ReactNode;
  shouldRotateOnlyOnDesktop?: boolean;
};
export function FlipCard(t0) {
  const $ = _c(59);
  const {
    backNode,
    boxProps: t1,
    cardProps: t2,
    customFlipIcon,
    frontNode,
    shouldRotateOnlyOnDesktop: t3
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const boxProps = t4;
  let t5;
  if ($[2] !== t2) {
    t5 = t2 === undefined ? {} : t2;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const cardProps = t5;
  const shouldRotateOnlyOnDesktop = t3 === undefined ? false : t3;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = theme.breakpoints.down("md");
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const isMobile = useMediaQuery(t6);
  const flipCardRef = useRef(null);
  const t7 = boxProps;
  let boxRest;
  let boxSx;
  if ($[5] !== t7) {
    ({
      sx: boxSx,
      ...boxRest
    } = t7);
    $[5] = t7;
    $[6] = boxRest;
    $[7] = boxSx;
  } else {
    boxRest = $[6];
    boxSx = $[7];
  }
  const t8 = cardProps;
  let cardRest;
  let cardSx;
  if ($[8] !== t8) {
    ({
      sx: cardSx,
      ...cardRest
    } = t8);
    $[8] = t8;
    $[9] = cardRest;
    $[10] = cardSx;
  } else {
    cardRest = $[9];
    cardSx = $[10];
  }
  let t9;
  if ($[11] !== shouldRotateOnlyOnDesktop) {
    t9 = () => {
      if (shouldRotateOnlyOnDesktop && flipCardRef.current) {
        flipCardRef.current.style.removeProperty("transform");
      }
    };
    $[11] = shouldRotateOnlyOnDesktop;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== isMobile) {
    t10 = [isMobile];
    $[13] = isMobile;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  useEffect(t9, t10);
  let t11;
  if ($[15] !== isMobile) {
    t11 = () => {
      if (!flipCardRef.current || !isMobile) {
        return;
      }
      flipCardRef.current.style.transform = "rotateY(-180deg)";
    };
    $[15] = isMobile;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const flipCard = t11;
  let t12;
  if ($[17] !== isMobile) {
    t12 = () => {
      if (!flipCardRef.current || !isMobile) {
        return;
      }
      flipCardRef.current.style.transform = "rotateY(0deg)";
    };
    $[17] = isMobile;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const flipCardBack = t12;
  let t13;
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      transform: {
        md: "rotateY(-180deg)"
      }
    };
    t14 = {
      transform: {
        md: "rotateY(-180deg)"
      }
    };
    $[19] = t13;
    $[20] = t14;
  } else {
    t13 = $[19];
    t14 = $[20];
  }
  let t15;
  if ($[21] !== boxSx) {
    t15 = {
      perspective: "1000px",
      "&:hover > div:first-child": t13,
      "&:focus-within > div:first-child": t14,
      ...boxSx
    };
    $[21] = boxSx;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      position: "relative",
      width: "100%",
      height: "100%",
      textAlign: "center",
      transformStyle: "preserve-3d",
      transition: "transform 0.6s"
    };
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      xs: "pointer",
      md: "default"
    };
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== cardSx) {
    t18 = {
      position: "absolute",
      width: "100%",
      height: "100%",
      cursor: t17,
      inset: 0,
      backfaceVisibility: "hidden",
      border: 0,
      ...cardSx
    };
    $[25] = cardSx;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      padding: 0,
      paddingBottom: 0,
      "&:last-child": {
        paddingBottom: 0
      }
    };
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== customFlipIcon) {
    t20 = customFlipIcon || <span aria-hidden="true" className="mask-icon mask-icon-loop" style={{
      position: "absolute",
      top: 5,
      right: 5,
      width: "24px",
      height: "24px"
    }} />;
    $[28] = customFlipIcon;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== frontNode || $[31] !== t20) {
    t21 = <CardContent sx={t19}>{frontNode}{t20}</CardContent>;
    $[30] = frontNode;
    $[31] = t20;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] !== cardRest || $[34] !== flipCard || $[35] !== t18 || $[36] !== t21) {
    t22 = <Card onClick={flipCard} sx={t18} {...cardRest}>{t21}</Card>;
    $[33] = cardRest;
    $[34] = flipCard;
    $[35] = t18;
    $[36] = t21;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      xs: "pointer",
      md: "default"
    };
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  let t24;
  if ($[39] !== cardSx) {
    t24 = {
      position: "absolute",
      width: "100%",
      height: "100%",
      cursor: t23,
      inset: 0,
      backfaceVisibility: "hidden",
      transform: "rotateY(-180deg)",
      border: 0,
      ...cardSx
    };
    $[39] = cardSx;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      padding: 0,
      paddingBottom: 0,
      "&:last-child": {
        paddingBottom: 0
      }
    };
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== customFlipIcon) {
    t26 = customFlipIcon || <span aria-hidden="true" className="mask-icon mask-icon-loop" style={{
      position: "absolute",
      top: 0,
      right: 0,
      width: "24px",
      height: "24px"
    }} />;
    $[42] = customFlipIcon;
    $[43] = t26;
  } else {
    t26 = $[43];
  }
  let t27;
  if ($[44] !== backNode || $[45] !== t26) {
    t27 = <CardContent sx={t25}>{backNode}{t26}</CardContent>;
    $[44] = backNode;
    $[45] = t26;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  let t28;
  if ($[47] !== cardRest || $[48] !== flipCardBack || $[49] !== t24 || $[50] !== t27) {
    t28 = <Card onClick={flipCardBack} sx={t24} {...cardRest}>{t27}</Card>;
    $[47] = cardRest;
    $[48] = flipCardBack;
    $[49] = t24;
    $[50] = t27;
    $[51] = t28;
  } else {
    t28 = $[51];
  }
  let t29;
  if ($[52] !== t22 || $[53] !== t28) {
    t29 = <Box ref={flipCardRef} sx={t16}>{t22}{t28}</Box>;
    $[52] = t22;
    $[53] = t28;
    $[54] = t29;
  } else {
    t29 = $[54];
  }
  let t30;
  if ($[55] !== boxRest || $[56] !== t15 || $[57] !== t29) {
    t30 = <Box sx={t15} tabIndex={0} {...boxRest}>{t29}</Box>;
    $[55] = boxRest;
    $[56] = t15;
    $[57] = t29;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  return t30;
}